import { render, staticRenderFns } from "./RziFitoSpecies.vue?vue&type=template&id=a4e09f0e&scoped=true&"
import script from "./RziFitoSpecies.vue?vue&type=script&lang=js&"
export * from "./RziFitoSpecies.vue?vue&type=script&lang=js&"
import style0 from "./RziFitoSpecies.vue?vue&type=style&index=0&id=a4e09f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e09f0e",
  null
  
)

export default component.exports